import { ADD_ACU_RESPONSE_TYPES, WIZARD_LIST } from "../utilities/constants";
import { getControllersData, getRandomStatusCode } from "../utilities/helpers";
import axiosInstance from "./axios";

// Fetch WIZARD data
export const fetchWizardList = async () => {
  try {
    const response = await axiosInstance.get(
      `${process.env.VUE_APP_BACK}/acu/models`
    );

    return getControllersData(response.data.controllers);
  } catch (error) {
    console.error("Failed to fetch wizards:", error);

    throw error;
  }
};

export const fetchSearchWizard = async (serial_number, model) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.VUE_APP_BACK}/acuSearch?serial_number=${serial_number}&model=${model}`
    );

    return {
      message: ADD_ACU_RESPONSE_TYPES[`${200}`],
      data: {
        ...WIZARD_LIST[0],
        comment: "controller for second floor",
        defaultName: `${response.data.model_name} ${response.data.serial_number || serial_number}`,
        versionNumber: response.data.fw_version || "1.162",
        name: response.data.model_name,
        ...response.data,
      },

    }

  } catch (error) {

    if (ADD_ACU_RESPONSE_TYPES[error.response.data.status]) {

      throw new CustomError(`${error.response.data.status}`, {
        ...ADD_ACU_RESPONSE_TYPES[error.response.data.status],
      });
    } else {


      throw new CustomError(`${error.response.data.status}`, {
        ...ADD_ACU_RESPONSE_TYPES[45],
      });
    }

  }
};


export const fetchCreateWizard = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${process.env.VUE_APP_BACK}/acuWithWizard`, data
    );

    return {
      success: true

    }
  } catch (error) {

    throw error;
  }
};

class CustomError extends Error {
  constructor(message, data) {
    super(message);
    this.name = "CustomError"; // Custom name for this error type
    this.data = data; // Assign data directly
  }
}
